import { Component, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LocationApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/location-api';
import { DowngradeSummaryResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/downgrade-summary.response';
import { BaseToastComponent } from '../../ui-components/toast-popup/base-toast-component';
import { SharedModule } from '../../ui-components/shared.module';
import { LockIconComponent } from '../../../@icons/lock-icon.component';
import { PremiumService } from '../../@services/front/premium.service';

/**
 * « Voici ce qui change » — montré UNE fois, au retour au palier gratuit.
 *
 * Le ton est factuel, jamais punitif : rien n'a été supprimé, ces espaces
 * restent consultables et les cultures en cours pleinement gérables. On informe,
 * on ne culpabilise pas.
 */
@Component({
  selector: 'vw-downgrade-toast',
  imports: [SharedModule, CommonModule, TranslateModule, LockIconComponent],
  templateUrl: './downgrade-toast.component.html',
  providers: [{ provide: LocationApi, useClass: LocationApi }],
})
export class DowngradeToastComponent
  extends BaseToastComponent
  implements OnChanges
{
  summary: DowngradeSummaryResponse | null = null;
  loading = false;

  private readonly premiumService = inject(PremiumService);

  constructor(private readonly locationApi: LocationApi) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue) {
      void this.load();
    }
  }

  acknowledge(upgrade = false): void {
    this.premiumService.acknowledgeDowngrade();
    this.onClose({ upgrade });
  }

  private async load(): Promise<void> {
    this.loading = true;
    try {
      this.summary = await this.locationApi.getDowngradeSummary();
    } catch {
      // Sans le détail, on ferme plutôt que d'afficher un écran vide anxiogène.
      this.acknowledge();
    } finally {
      this.loading = false;
    }
  }
}
